// extracted by mini-css-extract-plugin
export default {"wrapper":"ButtonWithIcon_wrapper__59hAC"};